import { render, staticRenderFns } from "./Traininglocations.vue?vue&type=template&id=bd2f105e&scoped=true&"
import script from "./Traininglocations.vue?vue&type=script&lang=js&"
export * from "./Traininglocations.vue?vue&type=script&lang=js&"
import style0 from "./Traininglocations.vue?vue&type=style&index=0&id=bd2f105e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2f105e",
  null
  
)

export default component.exports